// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rowBaseCss{display:flex;flex-direction:column;justify-content:center;align-items:center;padding:0;gap:10px;width:100%;min-height:70px;left:0}.selectedSpan{width:20px;height:20px;left:330px;top:25px;background-color:#879dc9;border:1.5px solid #4a669e;border-radius:50%}", ""]);
// Exports
module.exports = exports;
